import { Formatset } from '../interfaces/entities/formatset'

import { creatives, nativeCreatives } from './creatives'
import {
  FacebookFormatset,
  PerformanceAdvertisingFormatset,
} from './blueprints/formatsets'

const formats = {
  image: { name: 'image', label: 'Image' },
  carousel: { name: 'carousel', label: 'Carousel' },
}

export const formatsets: Formatset[] = [
  {
    id: '1',
    type: 'facebook',
    name: 'Format Set #1',
    data: {},
    creativeFormats: [formats.image],
    comment: null,
    creatives: [...creatives].slice(1),
    invalid: false,
    blueprint: FacebookFormatset,
    displayOrder: 1,
  },
  {
    id: '2',
    type: 'facebook',
    name: 'Format Set #2',
    data: {},
    creativeFormats: [formats.image, formats.carousel],
    comment: null,
    creatives: creatives,
    invalid: false,
    blueprint: FacebookFormatset,
    displayOrder: 2,
  },
  {
    id: '3',
    type: 'performance_advertising',
    name: 'Format Set #3',
    data: {},
    creativeFormats: [formats.image],
    comment: null,
    creatives: nativeCreatives,
    invalid: false,
    blueprint: PerformanceAdvertisingFormatset,
    displayOrder: 2,
  },
]
